import { render } from "./OuterSelectPage.vue?vue&type=template&id=af53633e&scoped=true&ts=true"
import script from "./OuterSelectPage.vue?vue&type=script&lang=ts"
export * from "./OuterSelectPage.vue?vue&type=script&lang=ts"

import "./OuterSelectPage.vue?vue&type=style&index=0&id=af53633e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af53633e"]])

export default __exports__